import React from 'react';
import {useState,useEffect,Component} from 'react';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';



/* IMPORTING FILES */
import Admin_login from './Admin/admin_login';
import Team_login from './Team/team_login';
import User_login from './User/user_login';
import Admin_createteam from './Admin/admin_createteam';
import Admin_teams from './Admin/admin_teams';
import Admin_addteammember from './Admin/admin_addteammember';
import Admin_teammembers from './Admin/admin_teammembers';
import Team_createuser from './Team/team_createuser';
import Team_users from './Team/team_users';
import Team_adddocument from './Team/team_adddocument';
import Team_user_documents from './Team/team_user_documents';
import Admin_all_documents from './Admin/admin_all_documents';
import Admin_users from './Admin/admin_users';
import Team_all_documents from './Team/team_all_documents';
import Team_projects from './Team/team_projects';
import Team_project_documents from './Team/team_project_documents';
import Team_company_documents from './Team/team_company_documents';
import Team_companies from './Team/team_companies';
import Admin_projects from './Admin/admin_projects';
import Admin_project_documents from './Admin/admin_project_documents';
import Admin_companies from './Admin/admin_companies';
import Admin_company_documents from './Admin/admin_company_documents';
import User_all_documents from './User/user_all_documents';
import User_projects from './User/user_projects';
import Admin_dashboard from './Admin/admin_dashboard';
import Team_dashboard from './Team/team_dashboard';
import User_dashboard from './User/user_dashboard';
import User_project_documents from './User/user_project_documents';
import Admin_user_documents from './Admin/admin_user_documents';





function Routestosite(){

    return(
<>
<Router>
   <Routes>

  
   /********************  BUSINESS SAMADHAN **********************/
   /************** DOCUMENT MANAGEMENT SYSTEM (DMS)***************/

   //DEFAULT PAGE LOAD
   <Route exact path='/' element={<User_login />} />

   //ADMIN PANEL
   <Route exact path='/adminpanel-login' element={<Admin_login />} />
   <Route exact path='/adminpanel-dashboard' element={<Admin_dashboard />} />
   <Route exact path='/adminpanel-create-team' element={<Admin_createteam />} />
   <Route exact path='/adminpanel-teams' element={<Admin_teams />} />
   <Route exact path='/adminpanel-add-new-teammember' element={<Admin_addteammember />} />
   <Route exact path='/adminpanel-teammembers' element={<Admin_teammembers />} />
   <Route exact path='/adminpanel-all-documents' element={<Admin_all_documents />} />
   <Route exact path='/adminpanel-users' element={<Admin_users />} />
   <Route exact path='/adminpanel-user-documents' element={<Admin_user_documents />} />
   <Route exact path='/adminpanel-projects' element={<Admin_projects />} />
   <Route exact path='/adminpanel-project-documents' element={<Admin_project_documents />} />
   <Route exact path='/adminpanel-companies' element={<Admin_companies />} />
   <Route exact path='/adminpanel-company-documents' element={<Admin_company_documents />} />

   //TEAM PANEL
   <Route exact path='/teampanel-login' element={<Team_login />} />
   <Route exact path='/teampanel-dashboard' element={<Team_dashboard />} />
   <Route exact path='/teampanel-create-user' element={<Team_createuser />} />
   <Route exact path='/teampanel-users' element={<Team_users />} />
   <Route exact path='/teampanel-add-document' element={<Team_adddocument />} />
   <Route exact path='/teampanel-user-documents' element={<Team_user_documents />} />
   <Route exact path='/teampanel-all-documents' element={<Team_all_documents />} />
   <Route exact path='/teampanel-projects' element={<Team_projects />} />
   <Route exact path='/teampanel-project-documents' element={<Team_project_documents />} />
   <Route exact path='/teampanel-companies' element={<Team_companies />} />
   <Route exact path='/teampanel-company-documents' element={<Team_company_documents />} />

   //USER PANEL
   <Route exact path='/user-login' element={<User_login />} />
   <Route exact path='/user-dashboard' element={<User_dashboard />} />
   <Route exact path='/user-all-documents' element={<User_all_documents />} />
   <Route exact path='/user-projects' element={<User_projects />} />
   <Route exact path='/user-project-documents' element={<User_project_documents />} />

   </Routes>
   </Router>
</>
    );


}

export default Routestosite;